import { Box } from '@mui/material'
import { FileRejection, FileWithPath } from 'react-dropzone'

export function getDropzoneData(file: FileWithPath, index: number) {
	if (typeof file === 'string') {
		return {
			key: index ? `${file}-${index}` : file,
			preview: file,
		}
	}

	return {
		key: index ? `${file.name}-${index}` : file.name,
		name: file.name,
		size: file.size,
		path: file.path,
		type: file.type,
		lastModified: file.lastModified,
	}
}

export function getErrorList(fileRejection: FileRejection) {
	const { errors } = fileRejection

	return (
		<Box component="ul" sx={{ marginTop: 1, paddingLeft: 1 }}>
			{errors.map((error) => (
				<Box key={error.code} component="li" sx={{ typography: 'caption', marginBottom: '4px' }}>
					{error.message}
				</Box>
			))}
		</Box>
	)
}
